import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../constants';
import { IsHelper } from './IsHelper';
import { UnwrapHelper } from './UnwrapHelper';
import { WrapHelper } from './WrapHelper';
export class UnwrapForwardValueHelper extends UnwrapHelper {
}
export class WrapForwardValueHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.ForwardValue;
    }
}
export class IsForwardValueHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.ForwardValue;
    }
}
export const hasForwardValue = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isForwardValue(context, node, tpe));
export const isOnlyForwardValue = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isForwardValue(context, node, tpe));
export const isForwardValue = (context, node, type) => context.builtins.isInterface(node, type, 'ForwardValue');

//# sourceMappingURL=forwardValue.js.map
